export default {
  emptyBtn: false,
  submitText: '保存',
  column: [
    {
      label: '上级节点',
      prop: 'parentName',
      display: true,
      formslot: true,
      span: 23,
    },
    {
      label: '上级属性',
      prop: 'parentParkTypeName',
      display: true,
      formslot: true,
      readonly: true,
      span: 23,
    },
    {
      label: '车位编号',
      prop: 'parkSpaceNo',
      display: true,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请输入车位编号',
          trigger: 'change',
        },
      ],
      span: 23,
    },
    {
      label: '车位状态',
      prop: 'carParkStatus',
      formslot: true,
      display: true,
      span: 23,
      rules: [
        {
          required: true,
          message: '请选择车位状态',
          trigger: 'change',
        },
      ],
    },
  ],
};
